module.exports = __webpack_public_path__ + "img/target.9fd14a27.svg";